import { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import assets from "../../assets";
import { useNotify } from "../../hooks/use-notify";
import "./styles.sass";

export const NotifyPopup = () => {
  const { notify, toggleNotify, timerRef } = useNotify();
  const [animate, setAnimate] = useState(false);

  const closeWithAnimation = () => {
    setAnimate(true);
    setTimeout(() => {
      toggleNotify(null);
      setAnimate(false);
    }, 250);
  };

  useEffect(() => {
    if (!notify) {
      setAnimate(false);
      return;
    }

    // Store timer in the shared ref so new calls can cancel it
    timerRef.current = setTimeout(() => {
      closeWithAnimation();
    }, 3000);

    return () => {
      // Clean up on re-trigger or unmount
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [notify]);

  if (!notify) return null;

  const {
    type = "information",
    title,
    description,
    ctaText,
    onClickCta,
  } = notify;

  const icon =
    type === "success"
      ? assets.ic_success_tick
      : type === "warning"
      ? assets.ic_warning
      : type === "error"
      ? assets.ic_wrong
      : assets.ic_info;

  return ReactDOM.createPortal(
    <section className={`notify_overlay ${animate ? "hide" : ""}`}>
      <section className={`notify_container ${type}`}>
        <div className="icon_wrapper">
          <img src={icon} alt="icon" />
        </div>

        <section className="content">
          <h4 className={`message ${type}`}>{title}</h4>
          <p className="desc">{description}</p>

          {ctaText && (
            <button onClick={onClickCta}>
              {ctaText}
            </button>
          )}
        </section>

        <img
          src={assets.ic_close}
          alt="close"
          className="close"
          onClick={closeWithAnimation}
        />
      </section>
    </section>,
    document.getElementById("notify-popup")
  );
};
